// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ty-0";
export var checkoutRateBadgeLink = "_ty-1";